module.exports = __webpack_public_path__ + "static/media/ship.65a116b5.svg";